import "@/App.css";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Problem } from "@/components/landing/Problem";
import { Intro } from "@/components/landing/Intro";
import { Audience } from "@/components/landing/Audience";
import { Curriculum } from "@/components/landing/Curriculum";
import { Instructor } from "@/components/landing/Instructor";
import { Benefits } from "@/components/landing/Benefits";
import { ClassInfo } from "@/components/landing/ClassInfo";
import { Pricing } from "@/components/landing/Pricing";
import { Doorprize } from "@/components/landing/Doorprize";
import { Faq } from "@/components/landing/Faq";
import { FinalCta } from "@/components/landing/FinalCta";
import { Footer } from "@/components/landing/Footer";
import { Overlays } from "@/components/landing/Overlays";

function App() {
    return (
        <div className="App bg-[#071B37] font-sans">
            <Header />
            <main>
                <Hero />
                <Problem />
                <Intro />
                <Audience />
                <Curriculum />
                <Instructor />
                <Benefits />
                <ClassInfo />
                <Pricing />
                <Doorprize />
                <Faq />
                <FinalCta />
            </main>
            <Footer />
            <Overlays />
        </div>
    );
}

export default App;
